<div style="width: 450px; height: 250px;" data-cy="case-item-form-remove-cancel">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="case-item-form-remove-cancel-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="case-item-form-remove-cancel-header">
      <div class="section-header-title" data-cy="case-item-form-remove-cancel-title">
        Please confirm ...
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; text-align: center;" data-cy="case-item-form-remove-cancel-content">
      @if (formStarted) {
        This form has already been started. Would you like to permanently delete this item or mark it as canceled?
      }
      @if (!formStarted) {
        Would you like to permanently delete this item or mark it as canceled?
      }
      <div style="margin-top: 26px;" data-cy="case-item-form-remove-cancel-actions">
        <button (click)="markAsCanceled()" class="tdo-button" style="margin-right: 6px; background-color: var(--tdo-secondary); color: white;" data-cy="case-item-form-remove-cancel-canceled-btn">Cancel Item</button>
        @if (canDelete) {
          <button (click)="delete()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="case-item-form-remove-cancel-delete-btn">Delete Item</button>
        }
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="case-item-form-remove-cancel-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="cancel()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="case-item-form-remove-cancel-close-btn">Close</button>
    </div>
  </div>
</div>
